import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

import { ucFirst } from 'utils/helpers';
import { userSelectors } from 'reducers';
import { texts } from 'utils/languages/fr';

import DashboardTitle from './DashboardTitle';
import { ActionButton, CustomDialogTitle } from 'components';
import { Box, Dialog, DialogContent, Link, Typography } from '@mui/material';

const DashboardTemplate = ({ children, showContactDialog, useDahboardPageTitle }) => {
    const internalUser = useSelector(userSelectors.getInternalUser);
    const [contactOpen, setContactOpen] = useState(false);

    return (
        <Box
            width="100%"
            padding={3}
            minHeight={theme => `calc(100% - ${theme.constants.footerHeight}px)`}
        >
            <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}>
                <DashboardTitle sx={showContactDialog ? { width: 'auto' } : undefined}>
                    {useDahboardPageTitle
                        ? texts.DASHBOARD
                        : `${texts.BIENVENUE} ${ucFirst(internalUser.firstName)},`}
                </DashboardTitle>
                {showContactDialog && (
                    <React.Fragment>
                        <ActionButton
                            variant="contained"
                            sx={{ borderRadius: '5px' }}
                            onClick={() => setContactOpen(true)}
                        >
                            {texts.CONTACT_US}
                        </ActionButton>
                        <Dialog
                            open={contactOpen}
                            maxWidth="lg"
                            sx={{ '.MuiDialog-paper': { minWidth: '600px' } }}
                        >
                            <CustomDialogTitle
                                title={texts.CONTACT_US_TITLE}
                                handleClose={() => setContactOpen(false)}
                            />
                            <DialogContent>
                                <Typography sx={{ mb: 2 }}>{texts.CONTACT_US_LINE_1}</Typography>
                                <Typography sx={{ mb: 2 }}>
                                    {texts.CONTACT_US_PHONE_1} /{' '}
                                    <Link
                                        underline="hover"
                                        href={`mailto:${texts.CONTACT_US_EMAIL_1}`}
                                    >
                                        {texts.CONTACT_US_EMAIL_1}
                                    </Link>
                                </Typography>
                            </DialogContent>
                        </Dialog>
                    </React.Fragment>
                )}
            </Box>
            {children}
        </Box>
    );
};

DashboardTemplate.propTypes = {
    showContactDialog: PropTypes.bool,
    useDahboardPageTitle: PropTypes.bool,
    children: PropTypes.node,
};

export default DashboardTemplate;
